/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  SwipeableDrawer,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useRecoilValue, useRecoilState } from "recoil";
import { configState } from "../lib/Store";

function RegisterForm(props) {

  const {goNextPage, goPreviousPage} = props;
  const config = useRecoilValue(configState);
  axios.defaults.withCredentials = true; // 세션유지

  const onErrorRequired = (msg) => {
    Swal.fire(msg + " 필수항목 입니다.");
  };

  const onRegister = async() => {
    let result = await axios.post(config.api+'/hr/join',data);
    if(result.data.success===0) {
        Swal.fire(result.data.msg);
        return;
    }
    if(result.data.success===1) {
        goNextPage();
        return;
    }

  };

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  // 데이타폼
  const [data, setData] = useState({
    phone: "",
    pass1: "",
    pass2: "",
    cname: "",
    mname: "",
  });

  return (
    <Grid direction="column">
      <Grid
        css={css`
          max-width: 300px;
          margin: 0 auto;
        `}
        className="regform"
        container
        flex="1"
        direction="column"
      >
        <Grid
          container
          width="100%"
          padding="5px"
          css={css`
            margin-top: 30px;
          `}
        >
          <TextField
            name="phone"
            onChange={onHandleData}
            label="연락처 : -없이 입력"
            size="small"
            style={{
              width: "100%",
            }}
          ></TextField>
        </Grid>

        <Grid container width="100%" padding="5px">
          <TextField
            type="password"
            name="pass1"
            onChange={onHandleData}
            label="비밀번호 : 4-12 자리 영문, 숫자"
            size="small"
            style={{
              width: "100%",
            }}
          ></TextField>
        </Grid>

        <Grid container width="100%" padding="5px">
          <TextField
            type="password"
            name="pass2"
            onChange={onHandleData}
            label="비밀번호 확인 : 4-12 자리 영문, 숫자"
            size="small"
            style={{
              width: "100%",
            }}
          ></TextField>
        </Grid>

        <Grid container width="100%" padding="5px">
          <TextField
            name="cname"
            onChange={onHandleData}
            label="센터명"
            size="small"
            style={{
              width: "100%",
            }}
          ></TextField>
        </Grid>
        <Grid container width="100%" padding="5px">
          <TextField
            name="mname"
            onChange={onHandleData}
            label="고객명"
            size="small"
            style={{
              width: "100%",
            }}
          ></TextField>
        </Grid>

        <Grid
          container
          justifyContent="center"
          css={css`
            margin-top: 30px;
          `}
        >
          <Button
            onClick={onRegister}
            variant="contained"
            fullWidth
            style={{
              marginBottom: "10px",
              background: "#0092a2",
              color: "white",
            }}
          >
            가입하기
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default RegisterForm;
